"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var TicketsDirectJoinFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_TicketsDirectJoinFill_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 15
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 6h-10A1.5 1.5 0 0 0 0 7.5v1.679c0 .138.113.247.248.277a1.143 1.143 0 0 1 0 2.231c-.135.03-.248.14-.248.277V13.5A1.5 1.5 0 0 0 1.5 15h10v-1a.5.5 0 0 1 1 0v1h2a1.5 1.5 0 0 0 1.5-1.5v-1.536c0-.138-.113-.247-.248-.277a1.143 1.143 0 0 1 0-2.231c.135-.03.248-.14.248-.277V7.5A1.5 1.5 0 0 0 14.5 6h-2v4.572a.5.5 0 0 1-1 0V6ZM5.738 7.732a.25.25 0 0 0-.476 0L4.77 9.246a.25.25 0 0 1-.237.172H2.94a.25.25 0 0 0-.147.453l1.288.935a.25.25 0 0 1 .09.28L3.681 12.6a.25.25 0 0 0 .384.28l1.288-.936a.25.25 0 0 1 .294 0l1.288.935a.25.25 0 0 0 .384-.28l-.491-1.513a.25.25 0 0 1 .09-.28l1.288-.935a.25.25 0 0 0-.147-.453H6.467a.25.25 0 0 1-.237-.172l-.492-1.514Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.293 4.124c-.487.225-.326.954.21.954h8.995a.5.5 0 0 0 .452-.713l-1.178-2.501a1.514 1.514 0 0 0-2.002-.729l-6.477 2.99Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_TicketsDirectJoinFill_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = TicketsDirectJoinFill;
exports["default"] = _default;